import React from 'react'
import PropTypes from "prop-types"
import { Row, Col, Checkbox, Form, FormGroup, ControlLabel } from 'react-bootstrap'
import Moment from "moment"
import { values } from 'lodash'
import { DateTimePicker } from 'react-widgets'

import MarkdownField from '../lib/MarkdownField.jsx'
import { str2date, date2str, sorted } from '../../lib/Tools'
import { getTripLength, getTripCode, getLeaderName } from '../../lib/TripTools'
import TagsList from '../tags/TagsList'

import { getText } from '../lib/text.js'
import TranslateLink from '../components/TranslateLink'
import Columns from '../components/Columns'
import Select from '../components/Select.jsx';
import Field, { FauxField } from "./TripForm.Field"

import "./TripForm.less"
// import "react-widgets/lib/less/react-widgets.less"

require('react-widgets-moment')(Moment)

const minDate = new Date()
minDate.setHours(0, 0, 0, 0)

const channelOptions = `
unknown;clientChannel_unknown
baidu;clientChannel_baidu
wechat_any;clientChannel_wechat_any
wechat_search;clientChannel_wechat_search
wechat_post;clientChannel_wechat_post
friends;clientChannel_friends
other;sh_Otros
`.split("\n").filter(x => x)
  .map(line => line.split(";"))
  .map(([ key, text ]) => ({ key, text: getText(text) }));
  
const reasonOptions = [
  { key:"unknown", text:"❓ No sabemos" },
  { key:"leisure", text:"🎉 Ocio" },
  { key:"business", text:"💼 Trabajo o negocios" },
  { key:"other", text:"Otros..." }
]

/*
 * Formulario del viaje
 */

class TripForm extends React.PureComponent {
  render() {
    const { trip } = this.props
    const onChange = (k, v) => this.props.onTripChange(k, v)
    const cks = ["name", "realName", "officialName", "leaderName", "wechat"]

    const code = getTripCode(trip)
    const chineseCities = values(this.props.cities).filter(city => city.country == "China").map(city => ({ key: city._id, text: `${city.name}(${city.chinese})` }))
    const chineseSorted = sorted(chineseCities, (a, b) => a.text.localeCompare(b.text))
    const CitiesOptions = [
      { key:"unknown", text: "Desconocido" },
      ...chineseSorted,
      { key:"other", text:"Otro..." }
    ]
    
    return (
      <div className="trip-form">
        <Row>

          <Col md={8}>
          
            {/* Fechas inicio y fin */}
            <ControlLabel>{getText("Fechas (A/M/D)")}</ControlLabel>
            <Form inline className="tripDates">
              <FormGroup>
                <ControlLabel>{getText("Inicio")}</ControlLabel>
                <div className="inlineDateWrapper">
                  <DateTimePicker
                    calendar
                    time={false}
                    format="YYYY/MM/DD"
                    value={trip.startDate && str2date(trip.startDate)}
                    onChange={d => {
                      onChange("startDate", date2str(d))
                    }}
                  />
                </div>
              </FormGroup>
              <FormGroup>
                <ControlLabel>{getText("Fin")}</ControlLabel>
                <div className="inlineDateWrapper">
                  <DateTimePicker
                    calendar
                    time={false}
                    min={trip.startDate && str2date(trip.startDate)} format="YYYY/MM/DD"
                    value={trip.endDate && str2date(trip.endDate)}
                    onChange={d => {
                      onChange("endDate", date2str(d))
                    }}
                    onToggle={() => {
                      if (
                        (trip.startDate && !trip.endDate)
                        || (trip.endDate < trip.startDate)
                      ) {
                        onChange("endDate", trip.startDate)
                      }
                    }}
                  />
                </div>
                <span>({getTripLength(trip)} {getText("días")})</span>
              </FormGroup>
            </Form>

            <Columns className="main-fields" n={2}>
              {
                [...cks.map(k => (
                  k == "leaderName"
                    ? (
                      <FauxField
                        label="Nombre del líder"
                        value={getLeaderName(trip) || "Falta nombre"}
                      />
                    )
                    : (
                      <Field 
                        trip={trip} 
                        key={k} 
                        k={k} 
                        v={trip[k]} 
                        onChange={v => onChange(k, v)} 
                      />
                    )
                )),                
                <Select
                  key="origin"
                  value={trip.origin || "unknown"}
                  comment={trip.originComment} 
                  onChange={x => onChange("origin", x)} 
                  onChangeComment={x => onChange("originComment", x)}
              
                  options={CitiesOptions}
                  label={getText("Lugar de origen")}
                  commentKey="other"
                  commentLabel={getText("Especifique el lugar de origen")}
                />
                ]
              }
              
            </Columns>
            
          </Col>
          
          <Col md={4}>
            <div className="client-code">
              <div style={{ margin: "auto" }}>
                <ControlLabel>{getText("Código para pagos")}:</ControlLabel>
                <code style={{ marginLeft: 10, fontSize: 18, fontWeight: 600, color: "black" }}>{code}</code>
              </div>
            </div>
            
            <MarkdownField
              onChange={x => onChange("note", x)}
              value={trip.note}
              label={<span>{getText("notas_contrato")} <TranslateLink text={trip.note} /></span>}
              placeholder={`*${getText("empty_md_field")}*`}
            />

            <MarkdownField
              onChange={x => onChange("returnDescription", x)}
              value={trip.returnDescription}
              label={(
                <span>
                  {getText("descripcion_retorno")}
                  {"  "}
                  <small>{getText("(para propuesta)")}</small>
                  <TranslateLink text={trip.returnDescription} />
                </span>
              )}
              placeholder={`*${getText("empty_md_field")}*`}
            />
          </Col>
          
        </Row>

        <hr />

        <Columns n={3}>
          <div>
            <Select
              value={trip.clientChannel || "unknown"}
              comment={trip.channelComment} 
              onChange={x => onChange("clientChannel", x)} 
              onChangeComment={x => onChange("channelComment", x)}
              
              options={channelOptions}
              label={getText("¿Cómo nos ha conocido?")}
              commentKey="other"
              commentLabel={getText("Especifique como nos ha conocido")}
            />
          </div>
          
          <div>
            <Select
              value={trip.travelReason || "unknown"}
              comment={trip.travelReasonComment} 
              onChange={x => onChange("travelReason", x)} 
              onChangeComment={x => onChange("travelReasonComment", x)}
              
              options={reasonOptions}
              label={getText("¿Por qué viaja?")}
              commentKey="other"
              commentLabel={getText("Más detalles:")}
            />
          </div>
          
          <div>
            <ControlLabel>{getText("¿Ya tiene visado?")}</ControlLabel>{"   "}
            <Checkbox
              style={{ marginLeft: 20, marginBottom: 10 }}
              checked={trip.hasVisa}
              onChange={evt => onChange("hasVisa", evt.target.checked)}
            >
              {getText("Tiene visado")}
            </Checkbox>
          </div>

        </Columns>
        
        <hr />
        
        <FormGroup>
          <ControlLabel>Etiquetas</ControlLabel>
          <div style={{ paddingLeft: 15 }}>
            <TagsList
              tagType="trips"
              allTags={this.props.tags}
              selectedTags={trip.tags}
              onChange={newSelection => onChange("tags", newSelection)}
            />
          </div>
        </FormGroup>
      </div>
    )
  }
}

TripForm.propTypes = {
  trip: PropTypes.object.isRequired,
  tags: PropTypes.object.isRequired,
  cities: PropTypes.object.isRequired,
  onTripChange: PropTypes.func.isRequired,
  onUnset: PropTypes.func.isRequired,
  username: PropTypes.func.isRequired,  
}

export default TripForm